import React from 'react';
import './FilterStyles.css';

const AGE_PROFILES = [
  'Young Pre-Parental',
  'Pre School Families',
  'School Families',
  'Mature Families',
  'Empty Nester',
  'Retired'
];

const INCOME_PROFILES = [
  'Struggling',
  'Getting by',
  'Managing',
  'Comfortable',
  'Affluent'
];

const ProfileFilter = ({ filter, onUpdate, onRemove }) => {
  const { ageProfiles = [], incomeProfiles = [] } = filter.values;

  const handleAgeToggle = (profile) => {
    const newAgeProfiles = ageProfiles.includes(profile)
      ? ageProfiles.filter(p => p !== profile)
      : [...ageProfiles, profile];

    onUpdate({
      ...filter,
      values: { ...filter.values, ageProfiles: newAgeProfiles }
    });
  };

  const handleIncomeToggle = (profile) => {
    const newIncomeProfiles = incomeProfiles.includes(profile)
      ? incomeProfiles.filter(p => p !== profile)
      : [...incomeProfiles, profile];

    onUpdate({
      ...filter,
      values: { ...filter.values, incomeProfiles: newIncomeProfiles }
    });
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <h3>Profile</h3>
        <button className="filter-remove-btn" onClick={onRemove}>×</button>
      </div>

      <div className="filter-section">
        <h4>Age Profile</h4>
        {AGE_PROFILES.map(profile => (
          <label key={profile} className="filter-checkbox">
            <input
              type="checkbox"
              checked={ageProfiles.includes(profile)}
              onChange={() => handleAgeToggle(profile)}
            />
            <span>{profile}</span>
          </label>
        ))}
      </div>

      <div className="filter-section">
        <h4>Income Profile</h4>
        {INCOME_PROFILES.map(profile => (
          <label key={profile} className="filter-checkbox">
            <input
              type="checkbox"
              checked={incomeProfiles.includes(profile)}
              onChange={() => handleIncomeToggle(profile)}
            />
            <span>{profile}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ProfileFilter;
